import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadLangues: false,
  isLoadRestau3: false,
  errorRestau3: "",
  langues: [],
  languesSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadLangues: state => state.isLoadLangues,
  isLoadRestau3: state => state.isLoadRestau3,
  errorRestau3: state => state.errorRestau3,
  langues: state => state.langues,
};

const mutations = {
  getLanguesSuccess(state, payload) {
    state.isLoadLangues = true;
    state.langues = payload.langues;
  },
  addLangueSuccess(state, payload) {
    // console.log({payload});
    // console.log("FROMMUATETTAGSUCCES");
    state.isLoadLangues = true;
    let langues = state.langues;
    langues.push(payload.data);
    state.langues = langues;
  },
  editLangueSuccess(state, payload) {
    console.log("FROM MUTATE");
    console.log(payload);
    state.isLoadLangues = true;
    let langues = state.langues;

    let newLangues = [];
    langues.map((langue, index) => {
      if (langue._id == payload.data._id) {
        newLangues.push({ ...payload.data });
      } else {
        newLangues.push({ ...langue });
      }
    });
    state.langues = [...newLangues];
  },
  deleteLangueSuccess(state, payload) {
    state.isLoadLangues = true;
    let langues = state.langues;

    let newLangues = [];
    langues.map((langue, index) => {
      if (langue._id != payload.data._id) {
        newLangues.push({ ...langue });
      }
    });
    state.langues = [...newLangues];
  },
  addLNGSuccess(state, payload) {
    state.isLoadLangues = true;

  },
  getLanguesError(state, error) {
    state.isLoadLangues = false;
    state.errorRestau3 = error;
  },
  addLangueError(state, error) {
    state.isLoadLangues = false;
    state.errorRestau3 = error;
  }
};

const actions = {
  getLangues({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/langues?restaurant=${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getLanguesSuccess", {
            langues: res.data
          });
        } else {
          commit("getLanguesError", "error:getLangues");
        }
      });
  },
  addLangue({ commit }, payload) {
    return axios
      .post(`${apiPath}/langues`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addLangueSuccess", res);
        } else {
          commit("addLangueError", "error:addLangue");
        }
        return res;
      });
  },
  editLangue({ commit }, payload) {
    console.log("FROM EDIT TAG AXIOS");
    console.log(payload);
    return axios
      .post(`${apiPath}/langues/${payload.id}`, payload.formdata, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editLangueSuccess", res);
        } else {
          commit("addLangueError", "error:addLangue");
        }
        return res;
      });
  },
  // SyncRestau({ commit }, payload,config) {
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  // },

  deleteLangue({ commit }, payload) {
    return axios
      .delete(`${apiPath}/langues/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePosSuccess", payload);
        // } else {
        //   commit("addPosError", "error:addPos");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addLNGSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
